import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../app.reducer';
import { OnesignalService } from '../services/onesignal.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';


@Component({
    selector: 'app-panel',
    templateUrl: './panel.component.html',
    styleUrls: ['./panel.component.scss'],
    standalone: false
})
export class PanelComponent implements OnInit, OnDestroy {

  openMenu = true;
  titleNav = "";
  isLoading;
  titleNavSubscription: Subscription = new Subscription();
  uisubs: Subscription = new Subscription();

  constructor( private store: Store<AppState>, private service: AuthService, private osservice:OnesignalService, public router: Router) {
   }  

  get showGlobalLoading(): boolean {
    return this.isLoading
      && !this.router.url.includes('/panel/home')
      && !this.router.url.includes('/panel/booking-now')
      && !this.isVideoRoute;
  }

  get isVideoRoute(): boolean {
    return this.router.url.includes('/panel/video');
  }

  ngOnInit() {
    this.titleNavSubscription = this.store.select('ui').subscribe(data =>{
      this.titleNav = data.title
    })
    this.uisubs = this.store.select('ui').subscribe( ui=>{
      this.isLoading = ui.isLoading;
    });

    this.osservice.init();
    // this.onSubscribe();
  }

  ngOnDestroy(){
    this.titleNavSubscription.unsubscribe();
    this.uisubs.unsubscribe();
  }

  logout(){
    Swal.fire({
      icon: 'warning',
      title: 'Cerrar sesión',
      text: 'Se cerrará tu sesión y se limpiarán los datos guardados en este navegador.',
      showCancelButton: true,
      confirmButtonText: 'Sí, cerrar sesión',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#1f4f82',
      cancelButtonColor: '#8aa0b6',
    }).then(result => {
      if (result.isConfirmed) {
        this.service.logout();
      }
    });
  }

  onSubscribe() {
    var OneSignal = window['OneSignal'] || [];
    console.log("Init OneSignal");
    OneSignal.push(["init", {
      appId: "d4970b4d-2068-492c-9dc0-9ad9ae35762f",
      autoRegister: false,
      allowLocalhostAsSecureOrigin: true,
      notifyButton: {
        enable: false
      }
    }]);
    console.log('OneSignal Initialized');
    OneSignal.push(function () {
      console.log('Register For Push');
      OneSignal.push(["registerForPushNotifications"])
    });
    OneSignal.push(function () {
      // Occurs when the user's subscription changes to a new value.
      OneSignal.on('subscriptionChange', function (isSubscribed) {
        console.log("The user's subscription state is now:", isSubscribed);
        OneSignal.getUserId().then(function (userId) {
          console.log("User ID is", userId);
        });
      });
    });

  }

}
